import { Outlet, useOutletContext } from "react-router-dom";
import Header from "../../template/Header";
import { PageLayoutOutletContext } from "../../template/PageLayout";
import GroupList from "../group/GroupList";

interface MainPageOutletContext extends PageLayoutOutletContext {}

function Main() {
  const outlet = useOutletContext<PageLayoutOutletContext>();

  return (
    <>
      <div className="container">
        <Header />
        <GroupList />
      </div>
      <Outlet context={outlet} />
    </>
  );
}

export type { MainPageOutletContext };
export default Main;
